export default "__VITE_ASSET__CmYKhB8M__"